/* eslint react/require-default-props: "off" */

import { Col, Row } from 'react-bootstrap';

import { Campaign as CampaignType } from 'common/types';
import Campaign from 'components/subscribe/property/Campaign';

function CampaignList({
  campaignList,
  errorMessage,
  handleSelection,
  hasNoScrolling = false,
}: {
  campaignList: CampaignType[];
  errorMessage?: string;
  handleSelection: (id: string) => void;
  hasNoScrolling?: boolean;
}) {
  const scrollingClass = hasNoScrolling ? 'footer-no-scrolling' : '';

  return (
    <>
      {errorMessage && (
        <Row className="m-0 mb-4 subscribe__property__error">
          <Col xs={12}>
            <div className="subscribe__content__error">{errorMessage}</div>
          </Col>
        </Row>
      )}
      <Row
        className={`m-0 mb-4 subscribe__property__campaigns ${scrollingClass}`}
      >
        {campaignList.map(campaign => (
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={4}
            xl={4}
            className="campaign-item"
            key={`col-${campaign.campaignURN}`}
          >
            <Campaign
              key={`campaign-${campaign.campaignURN}`}
              campaignURN={campaign.campaignURN}
              campaignName={campaign.name}
              isSelected={campaign.isSelected}
              handleSelection={handleSelection}
            />
          </Col>
        ))}
      </Row>
    </>
  );
}

export default CampaignList;
